// extracted by mini-css-extract-plugin
module.exports = {"academyContainer":"Academy_academyContainer__Mg9br","academy":"Academy_academy__YXH73"};